import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ItemMultiSelect } from '../multi-select/multi-select.component';
import { AdvSearch, AdvSearchProps } from './adv_search/adv-search';



export interface CustomSearch {
  advanced_search?: boolean,  // Ricerca avanzata
  view_advance_search?: boolean,
  defaultItemClass?: "col" | "col-1" | "col-2" | "col-3"| "col-4"| "col-5" | "col-6" | "col-7"| "col-8"| "col-9"| "col-10"| "col-11"| "col-12", /// col class
  header : (TextParamSearch | NumberParamSearch | FloatParamSearch | SelectParamSearch | MultiSelectParamSearch | CheckboxParamSearch | DatePickerParamSearch | ButtonParamSearch | BreakParamSearch | Select_MoreParamSearch)[],
  //  ParamSearch[], // Sempre visibile
  body? : (TextParamSearch | NumberParamSearch | FloatParamSearch | SelectParamSearch | MultiSelectParamSearch | CheckboxParamSearch | DatePickerParamSearch | ButtonParamSearch | BreakParamSearch | Select_MoreParamSearch)[] // Visibile se advanced_search = true
}

export enum ITEM_TYPE{
  TEXT = 'text',
  NUMBER = 'number',
  FLOAT = 'float',
  SELECT = 'select',
  MULTI_SELECT = 'multi_select',
  CHECKBOX = 'checkbox',
  DATE_PICKER = 'date_picker',
  // TABLE = 'table',
  BUTTON = 'button',

  BREAK = 'break',

  SELECT_MORE = "select_more"

}


export class TextParamSearch implements ParamSearch{
  public type : ITEM_TYPE = ITEM_TYPE.TEXT;
  value: any;
  constructor(public id: string,public  label: string | undefined,public  visible?: boolean,public  placeholder?: string,public nameClass?:string,public tooltip?:string,public initValue?: string, public labelPosition?: "top" | "left"|"right"){}
}

export class NumberParamSearch implements ParamSearch{
  public type : ITEM_TYPE = ITEM_TYPE.NUMBER;
  value: any;
  constructor(public id: string,public  label: string | undefined,public  visible?: boolean,public  placeholder?: string,public nameClass?:string,public tooltip?:string,public initValue?: number, public labelPosition?: "top" | "left"|"right"){}
}

export class FloatParamSearch implements ParamSearch{
  public type : ITEM_TYPE = ITEM_TYPE.FLOAT;
  value: any;
  constructor(public id: string,public  label: string | undefined,public  visible?: boolean,public  placeholder?: string,public nameClass?:string,public tooltip?:string,public initValue?: number, public labelPosition?: "top" | "left"|"right"){}
}

export class SelectParamSearch implements ParamSearch{
  public type : ITEM_TYPE = ITEM_TYPE.SELECT;
  
  public values : {key: string, value: string}[] = [];
  value: any;
  constructor(public id: string,public  label: string | undefined, public  visible?: boolean,public  placeholder?: string,public nameClass?:string,public tooltip?:string,public initValue?: string, public labelPosition?: "top" | "left"|"right"){}

  public addValues(key: string, value: string){
    if(this.values.filter(i => i.key == key).length == 0){
      this.values.push({key: key, value: value});
    }
  }
}

export class Select_MoreParamSearch implements ParamSearch{
  public type : ITEM_TYPE = ITEM_TYPE.SELECT_MORE;
  
  public values : {
                    key: string,
                    value: string,
                    body: (TextParamSearch | NumberParamSearch | FloatParamSearch | SelectParamSearch | MultiSelectParamSearch | CheckboxParamSearch | DatePickerParamSearch)[]
                  }[] = [];
  value: any;
  constructor(public id: string,public  label: string | undefined, public  visible?: boolean,public  placeholder?: string,public nameClass?:string,public tooltip?:string,public initValue?: string, public labelPosition?: "top" | "left"|"right"){}

  public addValues(key: string, value: string, body: (TextParamSearch | NumberParamSearch | FloatParamSearch | SelectParamSearch | MultiSelectParamSearch | CheckboxParamSearch | DatePickerParamSearch)[]){
    if(this.values.filter(i => i.key == key).length == 0){
      this.values.push({key: key, value: value, body: body});
    }
  }
}

export class MultiSelectParamSearch implements ParamSearch{
  
  public type : ITEM_TYPE = ITEM_TYPE.MULTI_SELECT;
  
  public values : ItemMultiSelect[] = [];
  value: any;
  constructor(public id: string,public  label: string | undefined, public  visible?: boolean,public  placeholder?: string,public nameClass?:string,public tooltip?:string,public initValue?: string, public labelPosition?: "top" | "left"|"right"){}

  public addValues(key: string, value: string, selected: boolean){
    if(this.values.filter(i => i.value == key).length == 0){
      this.values.push({value: key, label: value, selected: selected});
    }
  }
}

export class CheckboxParamSearch implements ParamSearch{
  public type : ITEM_TYPE = ITEM_TYPE.CHECKBOX;
  value: any;
  constructor(public id: string,public  label: string | undefined,public  visible?: boolean,public  placeholder?: string,public nameClass?:string,public tooltip?:string,public initValue?: boolean, public labelPosition?: "top" | "left"|"right"){
    if(initValue || initValue==undefined)
        this.value=true;
    else this.initValue=false;
  }
}

export class DatePickerParamSearch implements ParamSearch{
  public type : ITEM_TYPE = ITEM_TYPE.DATE_PICKER;
  value: any;
  constructor(public id: string,public  label: string | undefined,public  visible?: boolean,public  placeholder?: string,public nameClass?:string,public tooltip?:string,public initValue?: boolean, public labelPosition?: "top" | "left"|"right"){}
}

export class ButtonParamSearch implements ParamSearch{
  public type : ITEM_TYPE = ITEM_TYPE.BUTTON;
  value: any;
  constructor(public id: string,public  label: string | undefined,public  visible?: boolean,public  placeholder?: string,public nameClass?:string,public tooltip?:string,public initValue?: boolean, public labelPosition?: "top" | "left"|"right"){}
}

export class BreakParamSearch implements ParamSearch{
  type : ITEM_TYPE = ITEM_TYPE.BREAK;
  label?: string | undefined;
  visible?: boolean | undefined;
  placeholder?: string | undefined;
  value: any; 
  tooltip?: string | undefined;
  labelPosition?: 'top' | 'left' | 'right' | undefined;
  public nameClass: string = "col-12";
  constructor(public id: string){}
}


interface ParamSearch {
  // Attributi item
  id : string,         // id itemm
  label? : string,     // Label Item
  visible? : boolean,  // Visibilità item
  type: ITEM_TYPE,
  value?: any,
  // Attributi stile item
  placeholder? : string //Placeholder item,
  nameClass?: string,   // Stile item
  tooltip?: string,
  labelPosition?: "top" | "left"|"right";
}

export interface SearchParamAdv{
  header: {id: string, value: any, child: {id: string, value: any}[]}[],
  body: {id: string, value: any, child: {id: string, value: any}[]}[]
}


@Component({
  selector: 'app-advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.css']
})


export class AdvancedSearchComponent implements OnInit, OnChanges {

  @Input() customSearch : CustomSearch | undefined;

  @Output() callSearch : EventEmitter<SearchParamAdv> = new EventEmitter<SearchParamAdv>();
  @Output() callButton : EventEmitter<{id: string, body: SearchParamAdv}> = new EventEmitter<{id: string, body: SearchParamAdv}>();

  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  btnSearch : ButtonParamSearch | undefined;
  btnAdvanceSearch: ButtonParamSearch | undefined;

  constructor(private translate: TranslateService) { 
    this.innerWidth = window.innerWidth;
    this.btnSearch = new ButtonParamSearch("btnSearch", "advancedsearch.search", true);
    this.btnAdvanceSearch = new ButtonParamSearch("btnAdvance", "advancedsearch.advanced", true);
    this.btnAdvanceSearch.visible = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customSearch) {
      this.customSearch = changes.customSearch.currentValue;
      this.btnAdvanceSearch!.visible = this.customSearch?.advanced_search;
    }
  }

  ngOnInit(): void {}

  /**
   * Viene richiamato ad ogni modifica del valore di ogni campo
   * @param event 
   */
  notifyChange(event: any){
    if(event instanceof ButtonParamSearch){
      if(event.id == "btnAdvance"){
        if(this.btnAdvanceSearch!.visible){
          this.customSearch!.view_advance_search = !this.customSearch!.view_advance_search;
        }
      } else if(event.id == "btnSearch"){
        let finalJson = this.generateJSON();
        this.callSearch.emit(finalJson);
      } else {
        this.callButton.emit({id: event.id, body: this.generateJSON()});
      }
    } else if(event instanceof Select_MoreParamSearch){
      let key : string = event.value ? event.value: event.initValue;
      event.values.forEach(v => {
        if(v.key != key){
          //v.body.forEach(i => i.value = undefined);
          v.body.forEach(i => function(){
            if(i.id!="between")
                i.value = undefined
          });
        }
      })
    }
  }

  forceSearch(index: number,event :any){
    if((this.customSearch?.header[index].type=="select_more" && event.key=='Enter') 
        || ((this.customSearch?.header[index].type=='multi_select' || this.customSearch?.header[index].type=='select')))
        {
          let finalJson = this.generateJSON();
          this.callSearch.emit(finalJson);
        }
  }


  private generateJSON(){
    let objReturn : SearchParamAdv = {
      header: [],
      body: []
    }
    this.getItemValue(this.customSearch!.header!, objReturn.header!);
    /*if(this.customSearch?.view_advance_search)*/ this.getItemValue(this.customSearch!.body!, objReturn.body!);
    return objReturn;
  }


  private getItemValue(list: (TextParamSearch | NumberParamSearch | FloatParamSearch | SelectParamSearch | MultiSelectParamSearch | CheckboxParamSearch | DatePickerParamSearch | ButtonParamSearch | BreakParamSearch | Select_MoreParamSearch)[], listParams: any[]){
    list.forEach(i => {
      if(i instanceof TextParamSearch || i instanceof NumberParamSearch 
          || i instanceof FloatParamSearch || i instanceof SelectParamSearch 
          || i instanceof MultiSelectParamSearch || i instanceof CheckboxParamSearch){
        let obj = {id: i.id, value: i.value};
        if(obj.value) listParams.push(obj);
      } else if(i instanceof DatePickerParamSearch && i.value){
        let obj = {id: i.id, value: this.dateToString(this.toDate(i.value))};
        if(obj) listParams.push(obj);
      } else if(i instanceof Select_MoreParamSearch){
        let key : string = i.value ? i.value: i.initValue;
        if(i.values.filter(e => e.key == key)[0].body.length > 0){
          let obj = {id: i.id, value: key, child: []};
          this.getItemValue(i.values.filter(e => e.key == key)[0].body, obj.child);
          if(obj.value) listParams.push(obj);
        }
      }      
    })
  }

  private dateToString(dt: Date){
    let returnVal : string = "";
    try {
      returnVal = dt.toISOString();
    } catch (error) {}
    return returnVal;
  }
  
  private toDate(date : {year: number, month: number, day: number}){
    return new Date(date.year + "-" + (date.month) + "-" + (date.day + 1));
  }

}
